module.exports = __webpack_public_path__ + "static/media/focus-style-typography.c312eaf5.png";